import { AudioPlayer } from "@/components";
import { cdn_url } from "@/utils";
import { FC } from "react";

const AudioItem: FC<any> = ({ref, item, index , hideDelete}) => {
  return (<AudioPlayer ref={ref} hideDelete={hideDelete}  name={item?.split('/').pop()} audioData={`${item}`} />)
}

export default AudioItem